import { isFacetPageType } from '../useCases/pageTypeCheck'
import { getTermSpecificHeroDescription } from '../../domain/term/getTermSpecificHeroCopy'
import { localizeCenterToCentre } from '../../utils/localizeCenter'
import { isObject } from '../../utils/checks'
import { isLocationInUnitedStates } from '../location/useCases/isLocationInUnitedStates'
import { isGlobal } from '../term'

export const getDescriptionToRender = (
  copy,
  pageType,
  term,
  location,
  title,
  secondaryTerm,
  shouldDefaultRegionalize,
  count,
  locationName
) => {
  let descriptionToRender = copy?.description

  const isTermGlobal = isGlobal(term)

  if (
    isTermGlobal ||
    (isObject(location) && !isLocationInUnitedStates(location))
  ) {
    descriptionToRender = copy?.internationalDescription || copy?.description
  }

  const currentTerm = isFacetPageType(pageType) ? secondaryTerm : title
  descriptionToRender =
    getTermSpecificHeroDescription(currentTerm, count, locationName) ||
    descriptionToRender

  if (shouldDefaultRegionalize) {
    descriptionToRender = localizeCenterToCentre(descriptionToRender)
  }
  return descriptionToRender
}
